import React, { useState, useEffect } from "react";
import { useUserAuth } from "../context/UserAuthContext";
import Loader from "./Loader";
import Back from '../images/back3.webp';
import Nav from "./Nav";
import Dashboard from "./Dashboard";
import SalesEntry from "./SalesEntry";
import '../styles/Home.css';
import Notifications from "./Notifications";
import Guidelines from "./Guidelines";
import Management from "./Management";
import { db } from '../config/fbConfig';
import { collection, getDocs } from 'firebase/firestore';

const Home = () => {
  const { userData } = useUserAuth();
  const [activeComponent, setActiveComponent] = useState('management');
  const [loading, setLoading] = useState(true);
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    const loadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
      });
    };
    
    loadImage(Back).then(() => {
      if (userData) {
        setLoading(false);
        setActiveComponent(
          userData.status === "Cashier" ? 'salesEntry' :
          userData.status === "Staff" ? 'dashboard' :
          (localStorage.getItem('activeComponent') || 'dashboard')
        );
      }
    });
  }, [userData]);

  useEffect(() => {
    if (userData?.status !== "Cashier" && userData?.status !== "Staff") {
      localStorage.setItem('activeComponent', activeComponent);
    }
  }, [activeComponent, userData]);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const notificationsCollectionRef = collection(db, 'notifications');
        const notificationsSnapshot = await getDocs(notificationsCollectionRef);
        let notifications = notificationsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // Filter notifications for non-Admin/Supreme users based on their status or 'All'
        if (userData?.status !== "Admin" && userData?.status !== "Supreme") {
          notifications = notifications.filter(notification => 
            notification.audience === userData?.status || 
            notification.audience === "All" || 
            !notification.audience
          );
        }

        setNotificationCount(notifications.length);
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };

    if (userData) {
      fetchNotifications();
    }
  }, [userData]);

  if (loading || !userData) {
    return <Loader text={"Loading"} />;
  }

  const handleButtonClick = (component) => {
    setActiveComponent(component);
  };

  const isInactiveTeacherOrParent = userData && 
    (userData.status === "Teacher" || userData.status === "Parent") && 
    userData.isActive === false;

  return (
    <>          
      <div className="login-page-items homepage-back" style={{backgroundImage: `url(${Back})`}}> 
        <Nav />  
        {
          isInactiveTeacherOrParent ? (
            <span className="nav-links text-center font-red">{userData.firstName}, please contact admin</span>
          ) : (
            <ul className="nav-links row align-center">
              {userData.status === "Cashier" || userData.status === "Staff" || userData.status === "Accountant" || userData.status === "Admin" || userData.status === "Supreme" ? (
                <li>
                  <button onClick={() => handleButtonClick('dashboard')} className={`nav-link plain-button column align-center ${activeComponent === 'dashboard' ? 'active' : ''}`}>
                    <i className="fa-solid fa-chart-simple size2"></i> <span className="size5">Dashboard</span>
                  </button>
                </li>
              ) : null}
              {userData.status === "Admin" || userData.status === "Supreme" || userData.status === "Cashier" ? (
              <li>
                <button onClick={() => handleButtonClick('salesEntry')} className={`nav-link plain-button column align-center ${activeComponent === 'salesEntry' ? 'active' : ''}`}>
                  <i className="fa-solid fa-cart-shopping size2"></i> <span className="size5">Sales</span>
                </button>
              </li>
              ) : null}
              {userData.status === "Admin" || userData.status === "Supreme" || userData.status === "Accountant" || userData.status === "Cashier" ? (
                <li>
                  <button onClick={() => handleButtonClick('management')} className={`nav-link plain-button column align-center ${activeComponent === 'management' ? 'active' : ''}`}>
                    <i className={'fa-solid fa-money-bill size2'}></i>
                    <span className="size5">Management</span>
                  </button>
                </li>
              ) : null}
              <li>
                <button onClick={() => handleButtonClick('notifications')} className={`nav-link plain-button column align-center ${activeComponent === 'notifications' ? 'active' : ''}`}>
                  <div className="">
                    <i className="fa-solid fa-bell size2"></i>
                    <span className={`notifications-counter ${activeComponent === 'notifications' ? 'active' : ''}`}>{notificationCount}</span> <span className="size5">Notifications</span>
                  </div>
                </button>
              </li>
            </ul>
          )
        }       

        {(userData.status === "Admin" || userData.status === "Accountant" || userData.status === "Cashier" || userData.status === "Staff" || userData.status === "Supreme") && (
          <div className="scroll-fixed scroll-fixed4" style={{ display: activeComponent === 'dashboard' ? 'block' : 'none' }}>
            <Dashboard />
          </div>
        )}
        {(userData.status === "Admin" || userData.status === "Supreme" || userData.status === "Cashier") && (
        <div className="scroll-fixed scroll-fixed4" style={{ display: activeComponent === 'salesEntry' ? 'block' : 'none' }}>
          <SalesEntry />
        </div>
        )}
        {(userData.status === "Admin" || userData.status === "Supreme" || userData.status === "Accountant" || userData.status === "Cashier") && (
          <div className="scroll-fixed scroll-fixed4" style={{ display: activeComponent === 'management' ? 'block' : 'none' }}>
            <Management />
          </div>
        )}
        <div style={{ display: activeComponent === 'notifications' ? 'block' : 'none' }}>
          <Notifications />
        </div>
      </div>
    </>
  );
};

export default Home;